
// ###############################################################


// Utility to Shuffle Colors Based on Profile IDs
const shuffleArray = (array, salt) => {
    let m = array.length, t, i;

    const hash = salt.reduce((acc, id) => acc + parseInt(id, 10), 0);

    while (m) {
        i = Math.floor(hash % m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }

    return array;
};

// Generates distinct colors for the charts based on the number of profiles
export const generateColors = (numColors, profileIds) => {
    const predefinedColors = [

        '#b4af59', // Light Olive
        '#c0d725', // Lime Green
        '#64a7b8', // Steel Blue
        '#244664', // Dark Blue
        '#d48b20', // Orange
        '#e3ae51', // Gold
        '#b87528', // Bronze
        '#8B4A3E', // Rust / Red Earth (Deep warm accent)
        '#52405C', // Muted Eggplant (Rich earthy contrast)


        // '#356676', // Teal
        // '#CD6155', // Indian Red (Clay/Brick)
        // '#CC7A50', // Terracotta (Soft warm accent)
        // '#4E6E5D', // Sea Turtle Green (Deep calming green)
        // '#778899', // Light Slate Gray (Neutral Cool)
        // '#475B6B', // Stormy Slate (Deep neutral)
        // '#5D9B48', // Grass Green (Vibrant Nature)
        // '#D2691E', // Chocolate (Deep warmth)
        // '#884EA0', // Wisteria (Muted Purple)
        // '#566573', // Charcoal Grey (Dark Neutral)
        // '#EC7063', // Soft Rose (Warm Pinkish)
        // '#1E8449', // Deep Forest (True Green - distinct from Lime/Olive)
        // '#A569BD', // Amethyst (Lighter Purple)
        // '#5D6D7E', // Slate Blue (Greyish Blue)
        // '#D68910', // Mustard (distinct from Gold/Orange)
    ];

    // Generate fallback colors dynamically if needed
    const colors = [...predefinedColors];
    const saturation = 80; // High saturation for visibility
    const lightness = 50; // Moderate lightness for contrast

    for (let i = predefinedColors.length; i < numColors; i++) {
        const hue = (i * 360) / numColors;
        colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    // Shuffle colors based on profile IDs
    let shuffledColors = shuffleArray(colors, profileIds);

    // console.log("🖌️ Initial Profile IDs and Assigned Colors:");
    // profileIds.forEach((id, index) => {
    //     console.log(`🎨 Profile ID: ${id} -> Assigned Color: ${shuffledColors[index]}`);
    // });

    // ✅ Ensure Predicted Datasets Get the Same Color as Original Profile
    const colorMap = new Map(); // Store colors per unique profile ID

    profileIds.forEach((profileId, index) => {
        // console.log("Incoming profile ID:", profileId);

        if (colorMap.has(profileId)) {
            // If this profile ID already has a color, use the same one
            shuffledColors[index] = colorMap.get(profileId);
        } else {
            // Otherwise, assign and store the color
            colorMap.set(profileId, shuffledColors[index]);
        }
    });


    // console.log("✅ Final Profile IDs and Corrected Colors:");
    // profileIds.forEach((id, index) => {
    //     console.log(`🎨 Profile ID: ${id} -> Final Assigned Color: ${shuffledColors[index]}`);
    // });

    return shuffledColors;
};

